/**
 * AutoCount - Orders List Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { Link, useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

const orders = [
  { id: 1, orderNumber: "ORD-2026-001", customer: "Joe's Auto Repair", items: 5, total: "$241.90", status: "Processing", date: "Jul 6, 2026" },
  { id: 2, orderNumber: "ORD-2026-002", customer: "Quick Lube Plus", items: 12, total: "$225.50", status: "Shipped", date: "Jul 3, 2026" },
  { id: 3, orderNumber: "ORD-2026-003", customer: "Metro Auto Service", items: 8, total: "$606.85", status: "Pending", date: "Jul 6, 2026" },
  { id: 4, orderNumber: "ORD-2026-004", customer: "Highway Motors", items: 3, total: "$513.16", status: "Delivered", date: "Jun 28, 2026" },
];

function OrdersList(): JSX.Element {
  const navigate = useNavigate();

  const columns = [
    { Header: "Order #", accessor: "orderNumber", width: "15%" },
    { Header: "Customer", accessor: "customer", width: "25%" },
    { Header: "Items", accessor: "items", width: "10%" },
    { Header: "Total", accessor: "total", width: "15%" },
    { Header: "Status", accessor: "status", width: "15%" },
    { Header: "Date", accessor: "date", width: "15%" },
  ];

  const rows = orders.map((o) => ({
    ...o,
    orderNumber: (
      <MDTypography
        component={Link}
        to={`/orders/${o.id}`}
        variant="caption"
        color="info"
        fontWeight="medium"
      >
        {o.orderNumber}
      </MDTypography>
    ),
    status: (
      <MDTypography
        variant="caption"
        color={
          o.status === "Delivered" ? "success" :
          o.status === "Shipped" ? "info" :
          o.status === "Processing" ? "warning" : "secondary"
        }
        fontWeight="medium"
      >
        {o.status}
      </MDTypography>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Customer Orders
                </MDTypography>
                <MDButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={() => navigate("/orders/create")}
                >
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;New Order
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={{ defaultValue: 10, entries: [5, 10, 25, 50] }}
                  showTotalEntries={true}
                  canSearch={true}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default OrdersList;
